import { useState, MouseEvent } from "react";
import { Popover } from "@mui/material";
import { faQuestion } from "@fortawesome/free-solid-svg-icons";
import ButtonSmall from "components/Common/ButtonSmall/ButtonSmall";
import PageTitle from "components/Common/PageTitle/PageTitle";
import Tabs from "components/Common/Tabs/Tabs";
import DummyPortfolioContainer from "./DummyPortfolio.styles";
import DummyWeightInputTab from "./DummyWeightInputTab/DummyWeightInputTab";
import PortfolioManagerViewTab from "./PortfolioManagerViewTab/PortfolioManagerViewTab";
import Instructions from "./Instructions";

const DummyPortfolio = () => {
    const [instructionsAnchor, setInstructionsAnchor] =
        useState<HTMLElement | null>(null);

    const tabs = [
        {
            title: "Dummy Weight Input",
            value: "dummy-weight-input",
            content: <DummyWeightInputTab />,
        },
        {
            title: "Portfolio Manager View",
            value: "portfolio-manager-view",
            content: <PortfolioManagerViewTab />,
        },
    ];

    return (
        <DummyPortfolioContainer>
            <PageTitle
                title="DUMMY PORTFOLIO"
                actions={
                    <ButtonSmall
                        text="View instructions"
                        icon={faQuestion}
                        color="primary"
                        click={(event: MouseEvent<HTMLElement>) =>
                            setInstructionsAnchor(event.currentTarget)
                        }
                    />
                }
            />
            <Popover
                open={Boolean(instructionsAnchor)}
                anchorEl={instructionsAnchor}
                onClose={() => setInstructionsAnchor(null)}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <Instructions />
            </Popover>
            <Tabs defaultTab="portfolio-manager-view" tabs={tabs} />
        </DummyPortfolioContainer>
    );
};

export default DummyPortfolio;
